import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import './StaffPage.css';
import '../components/Letter.css';

const MyAppointmentPage = () => {
  const [censorData, setCensorData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get('/api/censorer/me');
        setCensorData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <div style={{padding:'20px'}}>Henter data...</div>;

  // Tjek om personen faktisk er beskikket
  const isAppointed = censorData?.beskikket_til && censorData.beskikket_til !== 'Ikke beskikket';

  if (!isAppointed) {
    return (
      <div className="table-card" style={{textAlign: 'center', padding: '3rem'}}>
        <h2 style={{color: '#666'}}>Ingen Beskikkelse</h2>
        <p>Du er registreret som underviser, men har ikke en aktiv censor-beskikkelse i øjeblikket.</p>
      </div>
    );
  }

  return (
    <div>
      {/* Handlingsbar (Skjules ved print) */}
      <div className="no-print" style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '20px'}}>
        <button 
          onClick={handlePrint} 
          className="action-btn"
          style={{display: 'flex', alignItems: 'center', gap: '8px'}}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
          Print / Gem som PDF
        </button>
      </div>

      {/* Selve Brevet (Designet som A4 papir) */}
      <div className="letter-container">
        
        {/* Brevpapir Header */}
        <div className="letter-header">
          <div>
            <h2 style={{margin: 0, color: '#003366'}}>SIRI</h2>
            <p style={{margin: 0, fontSize: '0.8rem', color: '#666'}}>Styrelsen for International<br/>Rekruttering og Integration</p>
          </div>
          <div style={{textAlign: 'right', fontSize: '0.9rem'}}>
            <p>{new Date().toLocaleDateString('da-DK', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>

        {/* Modtager */}
        <div className="letter-recipient">
          <p>
            {censorData.fornavn} {censorData.efternavn}<br/>
            {censorData.adresse}<br/>
            {censorData.postnummer} {censorData.forstad}
          </p>
        </div>

        {/* Overskrift */}
        <div className="letter-body">
          <h1 style={{fontSize: '1.4rem', marginBottom: '2rem'}}>Beskikkelse som censor</h1>

          <p>Kære {censorData.fornavn} {censorData.efternavn},</p>

          <p>
            Styrelsen for International Rekruttering og Integration (SIRI) har hermed fornøjelsen af at meddele, 
            at du er beskikket som censor inden for følgende område:
          </p>

          <div style={{
            background: '#f8f9fa', 
            padding: '15px', 
            borderLeft: '4px solid #003366', 
            margin: '20px 0',
            fontWeight: 'bold',
            fontSize: '1.1rem'
          }}>
            {censorData.beskikket_til === 'Alle' ? 'Alle Danskprøver (PD1, PD2, PD3, Studieprøven)' : censorData.beskikket_til}
          </div>

          <p>
            Beskikkelsen gælder indtil videre og forpligter dig til at virke som censor ved de prøver, 
            du bliver tildelt via fordelingssystemet.
          </p>

          <p>
            Du er registreret med følgende kontaktoplysninger i vores system:<br/>
            <strong>Email:</strong> {censorData.email}<br/>
            <strong>Telefon:</strong> {censorData.telefon}
          </p>

          <p>
            Venlig hilsen,<br/><br/>
            <strong>SIRI</strong><br/>
            Danskprøve administrationen
          </p>
        </div>

        {/* Footer */}
        <div className="letter-footer">
          <p>Dette er et automatisk genereret dokument fra SC-Admin.</p>
        </div>

      </div>
    </div>
  );
};

export default MyAppointmentPage;